<template>
  <x-page :title="pageTitle" :loading="loading">
    <template v-if="!loading">
      <div class="main">
        <!-- 概况 -->
        <x-card class="status">
          <div class="bg" />
          <div v-if="!afterSalesData.titleHiddenFlag" class="title">
            <div class="content">
              {{ afterSalesData.title }}
            </div>
            <div
              v-track="{
                name: '处理记录',
                id: '2ee13797-ae08-4c67-b4c9-5ed4fa856f2f',
              }"
              class="extra"
              @click="handleHistoryClick"
            >
              <div class="text">处理记录</div>
              <van-icon name="arrow" class="arrow" />
            </div>
          </div>
          <div v-if="!afterSalesData.subtitleHiddenFlag" class="desc">
            {{ afterSalesData.subTitle }}
          </div>
          <x-steps
            v-if="
              afterSalesData.timeFlowShowFlag && afterSalesData.timeFlow.length
            "
            class="steps"
            :list="afterSalesData.timeFlow.map(item => item.title)"
            :current="
              afterSalesData.timeFlow.find(item => !!item.activeFlag).title
            "
          />
        </x-card>

        <x-card
          v-if="afterSalesData.pickupAddressShowFlag"
          title="快递员上门取货"
          :class="_.pickup"
        >
          <div :class="_.basic">
            <div :class="_.name">{{ afterSalesData.pickupAddress.name }}</div>
            <div :class="_.phoneNumber">
              {{ afterSalesData.pickupAddress.phoneNo }}
            </div>
            <div :class="_.grow"></div>
            <!-- <div
              v-if="afterSalesData.pickupAddressEditFlag"
              :class="_.edit"
              @click="handlePickupAddressEditClick"
            >
              <img src="./images/detail/编辑.png" :class="_.icon" />
              编辑
            </div> -->
          </div>
          <div :class="_.address">
            {{
              `${afterSalesData.pickupAddress.province || ''}${
                afterSalesData.pickupAddress.city || ''
              }${afterSalesData.pickupAddress.area || ''}${
                afterSalesData.pickupAddress.detail || ''
              }`
            }}
          </div>
        </x-card>

        <!-- 退货回寄 -->
        <x-card
          v-if="afterSalesData.returnAddressShowFlag"
          class="address"
          title="退货回寄地址："
        >
          <div class="hd">
            <div class="content">
              {{ afterSalesData.refundAddress }}
            </div>
            <x-copy class="copy" :text="afterSalesData.refundAddress" />
          </div>
          <div class="ft">
            <div class="message">货物已寄出</div>
            <div
              v-track="{
                name: '填写回寄运单号',
                id: '81b374e1-ff98-447e-93d6-7240a86c2976',
              }"
              class="button"
              @click="handleExpressNoFormTriggerClick"
            >
              填写回寄运单号
            </div>
          </div>
        </x-card>

        <!-- 快递情况 -->
        <x-card
          v-if="afterSalesData.expressInfoShowFlag"
          class="express"
          @click.native="handleExpressProgressClick"
        >
          <img :src="require('./images/快递.png')" class="icon" />
          <section class="content">
            <div class="title">
              {{
                afterSalesData.expressInfo.action ||
                afterSalesData.expressInfo.actionInfo
              }}
            </div>
            <div class="desc">{{ afterSalesData.expressInfo.actionTime }}</div>
          </section>
          <van-icon name="arrow" class="arrow" />
        </x-card>

        <!-- 换货运单号 -->
        <x-card
          v-if="afterSalesData.exchangeWaybillNoShowFlag"
          class="expressNo"
        >
          {{ afterSalesData.exchangeWaybillNo }}
        </x-card>

        <!-- 售后详情信息 -->
        <x-card
          v-if="!afterSalesData.detailHiddenFlag"
          :title="afterSalesData.detailTitle"
          class="detail"
        >
          <div class="goods">
            <van-image
              fit="cover"
              :src="afterSalesData.commodityCoverPic"
              class="cover"
            />
            <div class="content">
              <div :class="['name', _._ellipsis3]">
                {{ afterSalesData.commodityTitle }}
              </div>
              <div class="desc">{{ afterSalesData.commoditySpecs }}</div>
            </div>
          </div>
          <div class="info">
            <div class="item">
              <div class="label">
                {{ AfterSalesType[type].substr(0, 2) }}原因
              </div>
              <div class="value">{{ afterSalesData.applyReason }}</div>
            </div>
            <div
              v-if="
                type === AfterSalesType.退款 || type === AfterSalesType.退货退款
              "
              class="item"
            >
              <div class="label">退款金额</div>
              <div class="value">¥{{ afterSalesData.refundAmount }}</div>
            </div>
            <div class="item">
              <div class="label">申请件数</div>
              <div class="value">{{ afterSalesData.quantity }}</div>
            </div>
            <div class="item">
              <div class="label">申请时间</div>
              <div class="value">{{ afterSalesData.createTime }}</div>
            </div>
            <div class="item">
              <div class="label">售后编号</div>
              <div class="value">
                <div class="content">
                  {{ afterSalesData.id }}
                </div>
                <x-copy class="copy" :text="afterSalesData.id" />
              </div>
            </div>
            <div class="item">
              <div class="label">备注说明</div>
              <div class="value">
                {{ afterSalesData.applyReasonAddDescription || '无' }}
              </div>
            </div>
            <div class="item">
              <div class="label">图片凭证</div>
              <div class="value">
                <template v-if="!afterSalesData.applyPic.length">无</template>
                <van-uploader
                  v-else
                  class="previewer"
                  :file-list="
                    afterSalesData.applyPic.map(url => ({
                      url: url,
                      isImage: true,
                    }))
                  "
                  :show-upload="false"
                  :deletable="false"
                />
              </div>
            </div>
          </div>
        </x-card>

        <!-- 联系客服 -->
        <x-card
          v-if="
            !afterSalesData.merchantTelHiddenFlag ||
            !afterSalesData.platformTelHiddenFlag
          "
          class="contact"
        >
          <div class="content">
            <div
              v-if="!afterSalesData.merchantTelHiddenFlag"
              v-track="{
                name: '联系商家',
                id: 'fddea0c9-3d5f-4a88-b691-b2c9de03e7ca',
              }"
              class="item"
              @click="handleContactClick(afterSalesData.merchantTel)"
            >
              <img class="icon" :src="require('./images/商家.png')" />
              <div class="text">联系商家</div>
            </div>
            <div
              v-if="!afterSalesData.platformTelHiddenFlag"
              v-track="{
                name: '平台客服',
                id: '012e0f73-f92b-4be0-b1f6-33bd76c8e516',
              }"
              class="item"
              @click="handleContactClick(afterSalesData.platformTel)"
            >
              <img class="icon" :src="require('./images/客服.png')" />
              <div class="text">平台客服</div>
            </div>
          </div>
        </x-card>

        <!-- 操作列表 -->
        <div v-hide-when-empty class="actions">
          <div
            v-if="afterSalesData.applyCustomerServiceShowFlag"
            v-track="{
              name: '客服介入',
              id: '3e0d0db7-3b0f-45f0-90a5-9da5403bc3c1',
            }"
            class="button"
            @click="handleCustomerServiceClick"
          >
            客服介入
          </div>
          <div
            v-if="afterSalesData.revokeShowFlag"
            v-track="{
              name: '撤销申请',
              id: '131cc309-596b-4e35-b70d-4a7c97cb2d10',
            }"
            class="button"
            @click="handleRevokeClick"
          >
            撤销申请
          </div>
          <div
            v-if="afterSalesData.reapplyShowFlag"
            v-track="{
              name: '重新申请',
              id: 'bd396008-f158-44a9-a880-782a18578fe5',
            }"
            class="button"
            @click="handleRenewClick"
          >
            重新申请
          </div>
          <div
            v-if="afterSalesData.delayShowFlag"
            v-track="{
              name: '延长收货',
              id: 'c852012c-6cca-4fbd-bd54-a921eaf1cf08',
            }"
            class="button"
            @click="handleDelayConfirmClick"
          >
            延长收货
          </div>
          <div
            v-if="afterSalesData.confirmShowFlag"
            v-track="{
              name: '确认收货',
              id: 'bc14011e-b246-4317-9ef8-f97ba4383dea',
            }"
            class="button"
            @click="handleConfirmClick"
          >
            确认收货
          </div>
          <div
            v-if="afterSalesData.updateWaybillNoShowFlag"
            v-track="{
              name: '修改运单号',
              id: '7db3df6b-c0e1-4997-8901-1dba1fdd89bd',
            }"
            class="button"
            @click="handleExpressNoFormTriggerClick"
          >
            修改运单号
          </div>
        </div>
        <div class="placeholder" />

        <van-action-sheet v-model="expressNoFormVisible" title="填写回寄运单号">
          <div class="expressNoForm">
            <x-animate duration="500ms">
              <transition
                :enter-active-class="`animate__animated ${
                  !expressNoConfirm
                    ? 'animate__fadeInLeft'
                    : 'animate__fadeInRight'
                }`"
              >
                <div v-if="!expressNoConfirm" key="input">
                  <input
                    v-model="expressNo"
                    v-fix-keyboard
                    type="text"
                    class="input"
                    placeholder="请输入快递单号"
                  />
                  <x-button class="btn" @click="handleExpressNoSubmit">
                    确定
                  </x-button>
                </div>
                <div v-else key="confirm">
                  <div class="item">
                    快递单号：{{ expressNoData.logisticsCode }}
                  </div>
                  <div class="item">
                    快递公司：{{ expressNoData.shippers[0].shipperName }}
                  </div>
                  <x-button class="btn" @click="handleExpressNoConfirm">
                    确定
                  </x-button>
                  <div class="extra">
                    运单信息有误，
                    <div class="link" @click="handleExpressNoEdit">
                      点击修改
                    </div>
                  </div>
                </div>
              </transition>
            </x-animate>
          </div>
        </van-action-sheet>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import { afterSalesBus, AfterSalesType } from './_model'
  import {
    apiExpressRecognitionValidateLogisticsCode,
    apiSaleAfterStandardEcommerceSaleAfterApplyCustomerService,
    apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceive,
    apiSaleAfterStandardEcommerceSaleAfterConfirmReceive,
    apiSaleAfterStandardEcommerceSaleAfterFindById,
    apiSaleAfterStandardEcommerceSaleAfterRevoke,
    apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNo,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { mapQuery, prepareData, submit, Track } from '@/utils'
  import { navigateTo } from '@/router'
  import { wait } from 'vtils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        // 售后 ID
        _id: 'id',
        fromInstantDelivery: 'fromInstantDelivery',
      }),
      Track.provideMark(() => ({
        page: '售后详情',
      })),
    ],

    data: () => ({
      AfterSalesType,

      // 页面级加载状态
      loading: true,

      // 售后数据
      afterSalesData: {},

      // 填写回寄运单号弹窗可见性
      expressNoFormVisible: false,

      // 运单号
      expressNo: '',

      // 运单号数据
      expressNoData: {},

      // 运单号确认
      expressNoConfirm: false,

      // 最新的 ID
      latestId: '',
    }),

    computed: {
      id() {
        return this.latestId || this._id
      },

      // 类型
      type() {
        return +this.afterSalesData.saleAfterType
      },

      // 页面标题
      pageTitle() {
        return AfterSalesType[this.type]
          ? `${AfterSalesType[this.type]}详情`
          : ''
      },
    },

    watch: {
      expressNoFormVisible(expressNoFormVisible) {
        if (!expressNoFormVisible) {
          wait(500).then(() => {
            this.expressNoConfirm = false
          })
        }
      },
    },

    mounted() {
      this.prepareData()

      this.$once(
        'hook:beforeDestroy',
        afterSalesBus.on('updateDetailId', id => {
          this.latestId = id
          this.prepareData()
        }),
      )
    },

    activated() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData() {
        const { afterSalesData } = await prepareData({
          afterSalesData: apiSaleAfterStandardEcommerceSaleAfterFindById({
            id: this.id,
          }),
        })
        this.afterSalesData = afterSalesData
        this.loading = false
      },

      // 点击处理记录
      handleHistoryClick() {
        navigateTo('AfterSalesHistory', {
          id: this.id,
        })
      },

      // 点击快递进展
      handleExpressProgressClick() {
        navigateTo('ExpressIndex', {
          afterSalesId: this.id,
        })
      },

      // 点击联系客服
      handleContactClick(phoneNumber) {
        dcb.makePhoneCall({
          phoneNumber: phoneNumber,
        })
      },

      // 点击填写回寄运单号
      handleExpressNoFormTriggerClick() {
        this.expressNoFormVisible = true
      },

      // 点击提交运单号
      handleExpressNoSubmit() {
        submit(async $ => {
          if (!this.expressNo) {
            return $.fail('请输入运单号')
          }
          await $.start('校验中...')
          this.expressNoData = await apiExpressRecognitionValidateLogisticsCode(
            {
              logisticsCode: this.expressNo,
            },
          )
          this.expressNoConfirm = true
        })
      },

      // 点击确认运单号
      handleExpressNoConfirm() {
        submit(async $ => {
          await $.start()
          await apiSaleAfterStandardEcommerceSaleAfterSaveWaybillNo({
            id: this.id,
            buyerLogisticsWaybillNo: this.expressNoData.logisticsCode,
            shipperCode: this.expressNoData.shippers[0].shipperCode,
            shipperName: this.expressNoData.shippers[0].shipperName,
          })
          this.expressNoFormVisible = false
          await this.prepareData()
          await $.success('操作成功')
        })
      },

      // 点击修改运单号
      handleExpressNoEdit() {
        this.expressNoConfirm = false
      },

      // 点击撤销申请
      handleRevokeClick() {
        submit(async $ => {
          await $.start('撤销中...')
          await apiSaleAfterStandardEcommerceSaleAfterRevoke({
            id: this.id,
          })
          await this.prepareData()
          await $.success('撤销成功')
        })
      },

      // 点击延长收货
      handleDelayConfirmClick() {
        submit(async $ => {
          await $.start('申请中...')
          await apiSaleAfterStandardEcommerceSaleAfterApplyDelayReceive({
            id: this.id,
          })
          await this.prepareData()
          await $.success('申请成功')
        })
      },

      // 点击确认收货
      handleConfirmClick() {
        submit(async $ => {
          await $.start('确认中...')
          await apiSaleAfterStandardEcommerceSaleAfterConfirmReceive({
            id: this.id,
          })
          await this.prepareData()
          await $.success('确认成功')
        })
      },

      // 点击重新申请
      handleRenewClick() {
        if (this.fromInstantDelivery) {
          navigateTo('AfterSalesRequestSubmit', {
            orderNo: this.afterSalesData.refOrderNo,
            id: this.id,
            fromInstantDelivery: true,
          })
        } else {
          navigateTo('AfterSalesRequestChoose', {
            commodityId: this.afterSalesData.commodityId,
            skuId: this.afterSalesData.skuId,
            orderNo: this.afterSalesData.refOrderNo,
            type: this.type,
            id: this.id,
          })
        }
      },

      // 点击申请客服介入
      handleCustomerServiceClick() {
        submit(async $ => {
          await $.start('申请中...')
          await apiSaleAfterStandardEcommerceSaleAfterApplyCustomerService({
            id: this.id,
          })
          await this.prepareData()
          await $.success('申请客服介入成功')
        })
      },

      // 点击上门取货编辑
      // async handlePickupAddressEditClick() {
      //   const address = await AddressBridge.chooseAddress()
      //   if (address) {
      //     console.log(address)
      //   }
      // },
    },
  })
</script>

<style lang="scss" scoped>
  .main {
    position: relative;
  }

  .status {
    .bg {
      position: absolute;
      top: -20px;
      left: -20px;
      right: -20px;
      bottom: 2px;
      z-index: -1;
      background: linear-gradient(180deg, #ff273c 0%, #ff111c 100%);
      clip-path: polygon(
        50% 0%,
        100% 0,
        100% 35%,
        100% 70%,
        85% 91%,
        49% 100%,
        17% 92%,
        0% 70%,
        0% 35%,
        0 0
      );
    }

    .title {
      display: flex;
      align-items: center;

      .content {
        flex-grow: 1;
        font-size: 16px;
        font-weight: bold;
        color: #222222;
      }

      .extra {
        flex-shrink: 0;
        margin-left: 8px;
        display: flex;
        align-items: center;

        .text {
          font-size: 12px;
          color: #888888;
        }

        .arrow {
          margin-left: 2px;
          font-size: 12px;
          color: #bebebe;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }

    .desc {
      margin-top: 4px;
      font-size: 12px;
      color: #888888;
    }

    .steps {
      margin-top: 20px;
      padding: 0;
    }
  }

  .address {
    .hd {
      display: flex;
      align-items: baseline;

      .content {
        flex-grow: 1;
        font-size: 14px;
        color: #888888;
        line-height: 20px;
      }

      .copy {
        flex-shrink: 0;
        margin-left: 12px;
      }
    }

    .ft {
      margin-top: 12px;
      display: flex;
      align-items: center;

      .message {
        font-size: 14px;
        color: #222222;
      }

      .button {
        margin-left: 12px;
        border-radius: 1000px;
        border: 1px solid #ff1c2d;
        font-size: 14px;
        color: #ff1c2d;
        padding: 6px 15px;

        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  .express {
    display: flex;
    align-items: center;

    .icon {
      flex-shrink: 0;
      width: 38px;
      height: 38px;
    }

    .content {
      margin-left: 12px;
      flex-grow: 1;

      .title {
        font-size: 14px;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
      }

      .desc {
        margin-top: 4px;
        font-size: 12px;
        color: #888888;
      }
    }

    .arrow {
      flex-shrink: 0;
      font-size: 14px;
      color: #bebebe;
    }

    &:active {
      opacity: 0.8;
    }
  }

  .expressNo {
    font-size: 14px;
    color: #222222;
  }

  .expressNoForm {
    padding: 20px;
    height: 210px;
    box-sizing: border-box;
    overflow: hidden;

    .input {
      appearance: none;
      border: none;
      box-shadow: none;
      outline: none;
      border-radius: 0;
      width: 100%;
      border-radius: 4px;
      border: 1px solid #e0e0e0;
      font-size: 16px;
      color: #222222;
      padding: 10px 12px;
      box-sizing: border-box;
    }

    .btn {
      margin-top: 24px;
    }

    .item {
      font-size: 16px;
      color: #222222;

      + .item {
        margin-top: 12px;
      }
    }

    .extra {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #888888;

      .link {
        color: #2e7dff;

        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  .detail {
    .goods {
      display: flex;
      align-items: center;

      .cover {
        flex-shrink: 0;
        width: 85px;
        height: 85px;
        border-radius: 8px;
        overflow: hidden;
      }

      .content {
        flex-grow: 1;
        margin-left: 12px;

        .name {
          font-size: 14px;
          color: #222222;
          line-height: 20px;
        }

        .desc {
          margin-top: 8px;
          font-size: 12px;
          color: #888888;
        }
      }
    }

    .info {
      margin-top: 20px;

      .item {
        display: flex;
        margin-top: 12px;

        .label {
          flex-shrink: 0;
          font-size: 12px;
          color: #888888;
        }

        .value {
          flex-grow: 1;
          margin-left: 24px;
          display: flex;
          font-size: 12px;
          color: #222222;
          overflow: hidden;
          word-break: break-all;

          .copy {
            margin-left: 12px;
          }

          .previewer {
            ::v-deep .van-uploader__preview {
              border-radius: 3px;
              overflow: hidden;
            }
          }
        }
      }
    }
  }

  .contact {
    .content {
      display: flex;
      align-items: center;
      justify-content: center;

      .item {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          width: 18px;
          height: 17px;
          pointer-events: none;
        }

        .text {
          margin-left: 8px;
          font-size: 14px;
          font-weight: bold;
          color: #1d1d1c;
        }

        + .item {
          border-left: 1px solid #d8d8d8;
        }

        &:active {
          opacity: 0.8;
        }
      }
    }
  }

  .actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px -1px 2px 0px rgba(239, 239, 239, 0.5);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: content-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .button {
      border-radius: 1000px;
      border: 1px solid #bebebe;
      font-size: 14px;
      color: #222222;
      padding: 5px 15px;
      margin-right: 12px;

      &:active {
        background-color: #efefef;
      }
    }

    + .placeholder {
      height: 50px;
    }
  }
</style>

<style lang="scss" module>
  .pickup {
    .basic {
      display: flex;
      align-items: center;

      .name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        font-style: normal;
      }

      .phoneNumber {
        margin-left: 8px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        font-style: normal;
      }

      .grow {
        flex-grow: 1;
      }

      .edit {
        display: flex;
        align-items: center;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 11px;
        color: #ff202a;
        line-height: 16px;
        font-style: normal;
        background-color: white;

        .icon {
          width: 11px;
          height: 11px;
          margin-right: 6px;
        }

        &:active {
          filter: contrast(0.9) opacity(0.9);
        }
      }
    }

    .address {
      margin-top: 4px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 16px;
      font-style: normal;
    }
  }
</style>
